// Add this as a new component: TableCell.js
import React from 'react';

const TableCell = ({ value, previousValue, formatter, onHover, onLeave, rowName }) => {
  const handleMouseOver = (e) => {
    if (previousValue === undefined || previousValue === null) return;
    
    // Calculate percentage change
    const currentNum = typeof value === 'number' ? value : parseFloat(value);
    const prevNum = typeof previousValue === 'number' ? previousValue : parseFloat(previousValue);
    
    if (isNaN(currentNum) || isNaN(prevNum) || prevNum === 0) return;
    
    const percentChange = ((currentNum - prevNum) / Math.abs(prevNum)) * 100;
    const formattedPercent = percentChange.toFixed(2);
    const isPositive = percentChange > 0;
    
    // Build content for tooltip
    const content = (
      <div>
        <div>{rowName}</div>
        <div>Current: {formatter ? formatter(value) : value}</div>
        <div>Previous: {formatter ? formatter(previousValue) : previousValue}</div>
        <div>
          Change: <span className={isPositive ? 'positive' : 'negative'}>
            {isPositive ? '+' : ''}{formattedPercent}%
          </span>
        </div>
      </div>
    );
    
    // Get position for tooltip
    const rect = e.currentTarget.getBoundingClientRect();
    const position = {
      x: rect.left + window.scrollX,
      y: rect.top + window.scrollY - 10 // Position above the cell
    };
    
    onHover(position, content);
  };
  
  return (
    <td 
      onMouseOver={handleMouseOver}
      onMouseLeave={onLeave}
    >
      {formatter ? formatter(value) : value}
    </td>
  );
};

export default TableCell;